module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/hero-8e74d1cd06ba7d8ce2a3a487740ee7e3.jpg";